import { CASE_CARD_PRODUCT, CLAIM_PANEL, PRODUCT } from '@/consts';

import { i18n } from '@lingui/core';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const metaTags = {
  [PRODUCT.VEHICLE_DAMAGE]: {
    title: i18n.t('Serwis samoobsługowy dopłaty do odszkodowań OC AC'),
    description: i18n.t(
      'Skorzystaj z samoobsługowego serwisu odszkodowawczego, w którym możesz sprzedać swoją szkodę w zamian za konkretną dopłatę do odszkodowania.'
    ),
  },
  [PRODUCT.VEHICLE_DAMAGE_TRANSPORT]: {
    title: i18n.t('Serwis samoobsługowy dopłaty do odszkodowań OC AC'),
    description: i18n.t(
      'Skorzystaj z samoobsługowego serwisu odszkodowawczego, w którym możesz sprzedać swoją szkodę w zamian za konkretną dopłatę do odszkodowania.'
    ),
  },
  [PRODUCT.HOUSE_HOLD]: {
    title: i18n.t(
      'Serwis samoobsługowy dopłaty do odszkodowań za szkody na nieruchomości'
    ),
    description: i18n.t(
      'Skorzystaj z samoobsługowego serwisu odszkodowawczego, w którym możesz sprzedać swoją szkodę na nieruchomości w zamian za konkretną dopłatę do odszkodowania.'
    ),
  },
  [PRODUCT.TRANSMISSION]: {
    title: i18n.t('Wniosek o służebność przesyłu'),
    description: i18n.t(
      'Kup gotowe pismo dotyczące ustanowienia służebności przesyłu. Uzupełnij prosty formularz i pobierz przygotowany dokument.'
    ),
  },
  [PRODUCT.PIT]: {
    title: i18n.t('Pobierz PIT-11 - Helpfind'),
    description: i18n.t(
      'Pobierz swój PIT-11 od Helpfind. Sprawdź szczegóły rozliczenia.'
    ),
  },
  [CASE_CARD_PRODUCT.SKD]: {
    title: 'Dodaj załączniki do swojej sprawy — szybka analiza z Helpfind',
    description:
      'Dodaj dokumenty kredytowe i przyspiesz analizę sprawy, bezpiecznie i szybko.',
  },
  [CASE_CARD_PRODUCT.PARABANKS]: {
    title:
      'Dodaj załączniki do swojej sprawy — szybka analiza kredytu w parabanku',
    description:
      'Dodaj dokumenty dotyczące Twojego kredytu w parabanku i przyspiesz analizę sprawy.',
  },
  [CASE_CARD_PRODUCT.HOUSE_HOLD]: {
    title: 'Dodaj załączniki do swojej sprawy — bezpłatna analiza z Helpfind',
    description:
      'Dodaj dokumenty dotyczące Twojej szkody na nieruchomości i przyspiesz analizę sprawy.',
  },
  [CASE_CARD_PRODUCT.VEHICLE_DAMAGE]: {
    title: 'Dodaj załączniki do swojej sprawy — szybka analiza z Helpfind',
    description:
      'Dodaj dokumenty dotyczące Twojej szkody komunikacyjnej i przyspiesz analizę sprawy.',
  },
  [CASE_CARD_PRODUCT.RETIREMENT]: {
    title: 'Dodaj załączniki do swojej sprawy — szybka analiza z Helpfind',
    description:
      'Dodaj dokumenty dotyczące Twojej emerytury i bezpiecznie przyspiesz analizę sprawy.',
  },
  [CASE_CARD_PRODUCT.DRYING]: {
    title: 'Dodaj załączniki do swojej sprawy — bezpłatna analiza z Deepdry',
    description:
      'Dodaj dokumenty dotyczące osuszania Twojej nieruchomości i przyspiesz analizę sprawy.',
  },
  [CASE_CARD_PRODUCT.WIBOR]: {
    title: 'Dodaj załączniki do swojej sprawy — bezpłatna analiza z Helpfind',
    description: 'Dodaj dokumenty dotyczące Twojego kredytu hipotecznego',
  },
  [CASE_CARD_PRODUCT.POLISOLOKATY]: {
    title: 'Dodaj załączniki do swojej sprawy — bezpłatna analiza z Helpfind',
    description:
      'Dodaj dokumenty dotyczące Twojej polisolokaty i przyspiesz analizę sprawy.',
  },
  [CASE_CARD_PRODUCT.SALARY_EQUALIZATION]: {
    title: 'Dodaj załączniki do swojej sprawy — bezpłatna analiza z Helpfind',
    description:
      'Dodaj dokumenty dotyczące wyrównania wynagrodzenia i przyspiesz analizę sprawy.',
  },
  [CLAIM_PANEL]: {
    title: 'Sprawdź status swojej sprawy',
    description:
      'Sprawdź status swojej sprawy, zobacz datę rozpraw i dowiedz się, co dalej.',
  },
} as Record<number, { title: string; description: string }>;

const SEO = ({ id }: { id: number }) => {
  const Component = () => {
    if (id in metaTags) {
      return (
        <Helmet>
          <title>{metaTags[id].title}</title>
          <meta name={'description'} content={metaTags[id].description} />
        </Helmet>
      );
    }
    return (
      <Helmet>
        <title>Panel klienta Helpfind</title>
        <meta
          name={'description'}
          content={'Dodaj załączniki do swojej sprawy'}
        />
      </Helmet>
    );
  };

  return (
    <HelmetProvider>
      <Component />
    </HelmetProvider>
  );
};

export default SEO;
